module.exports = "/_next/static/files/9896fd182307abace0cb24a6977ed55a.svg";